<template>
  <div class="drugDosageList">
    <div style="padding-bottom: 20px">
      <el-radio-group v-model="conditions" @change="tabConditions">
        <el-radio-button label="2">按月</el-radio-button>
        <el-radio-button label="3">按年</el-radio-button>
      </el-radio-group>
      <!--      <el-button @click="goback" style="float: right">返回</el-button>-->
    </div>
    <div style="margin-bottom: 20px">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
        <el-form-item label="月份区间" label-width="70px" v-if="conditions === '2'">
          <el-date-picker
              @input="search"
              v-model="searchForm.monthTime"
              value-format="yyyy-MM-dd"
              type="monthrange"
              style="width: 220px"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="年份" label-width="40px" v-if="conditions === '3'">
          <el-date-picker
              @input="search"
              v-model="searchForm.startYear"
              type="year"
              value-format="yyyy"
              style="width: 220px"
              placeholder="开始年份"
              unlink-panels>
          </el-date-picker>
          -
          <el-date-picker
              @input="search"
              v-model="searchForm.endYear"
              type="year"
              style="width: 220px"
              value-format="yyyy"
              unlink-panels
              placeholder="结束年份">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="药品编码" label-width="80px">
          <el-input style="width: 140px"  @input="search" clearable v-model="searchForm.drugCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="厂家编码" label-width="80px">
          <el-input style="width: 140px"  @input="search" clearable v-model="searchForm.FactoryCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="代理商" label-width="60px">
          <DicInput @fieldId="fieldId($event,'operatorId')" :initName="searchForm.operatorId" :dicType="6"></DicInput>
        </el-form-item>
      </el-form>
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="date"
            :label="timeName">
          <template slot-scope="scope">
            <span v-if="conditions==='2'">{{scope.row.year}}-{{scope.row.month}}</span>
            <span v-if="conditions==='3'">{{scope.row.year}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="drugName"
            align="center"
            label="药品名称">
        </el-table-column>
        <el-table-column
            prop="operatorName"
            align="center"
            label="代理商名称">
        </el-table-column>
        <el-table-column
            prop="dose"
            align="center"
            label="剂量">
        </el-table-column>
        <el-table-column
            prop="unit"
            align="center"
            label="单位">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <!--    <div style="margin-top: 20px">-->
    <!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
    <!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import DicInput from '@/components/DicInput.vue'
export default {
  name: "drugDosageList",
  data() {
    return {
      conditions: "2",
      pickerType:'date',
      searchForm:{
        dayTime: [],
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
        code:'',
        operatorId:'',
        FactoryCode:'',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      tableData:[],
      timeName:'日期'
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  methods: {
    fieldId(item,name){
      if(item.id){
        this.searchForm[name]=item.id
      }else {
        this.searchForm[name]=''
      }
    },
    //
    tabConditions(){
      let url = ''
      let data = {}
      switch (this.conditions) {
        case "2":
          url = '/Statistic/PFStatistic/GetMonthDrugSale'
          data = {
            start: this.searchForm.monthTime[0],
            end: this.searchForm.monthTime[1],
            cupTypeCode: this.searchForm.cupTypeCode,
          }
          this.timeName='月份'
          break;
        default:
          data = {
            yearStart: this.searchForm.startYear,
            yearEnd: this.searchForm.endYear,
            cupTypeCode:this.searchForm.cupTypeCode
          }
          this.timeName='年份'
          url = '/Statistic/PFStatistic/GetYearDrugSale'
      }
      this.init(url, data)
    },
    search(){
      this.tabConditions()
    },
    init(url, data) {
      this.axios
          .get(url, {params: data})
          .then((res) => {
            this.tableData = res
            this.tableData.forEach(item=>{
              if(item.createTime){
                item.createTime=this.dayjs(item.createTime).format('YYYY/MM/DD HH:mm')
              }
            })
          })
    },
    // ----------分页控制-------------
    clear(){
      this.searchForm={
        dayTime: [],
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
        code:''
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.drugDosageList {

}
</style>